"use client";

import * as React from "react";
import Link from "next/link";

import { footerLinks } from "@/config/site";
import { cn } from "@/lib/utils";
import { ModeToggle } from "@/components/layout/mode-toggle";

import { NewsletterForm } from "../forms/newsletter-form";
import { Icons } from "../shared/icons";
import { useCallback, MouseEvent } from "react";

export function SiteFooter({ className }: React.HTMLAttributes<HTMLElement>) {
  const handleCookiePreferencesClick = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    window.dispatchEvent(new Event("cookie-consent:open"));
  }, []);

  return (
    <footer className={cn("border-t", className)}>
      <div className="container grid max-w-6xl grid-cols-2 gap-6 py-14 md:grid-cols-5">
        {footerLinks.map((section) => (
          <div key={section.title}>
            <span className="text-sm font-medium text-foreground">
              {section.title}
            </span>
            <ul className="mt-4 list-inside space-y-3">
              {section.items?.map((link) => (
                <li key={link.title}>
                  <Link
                    href={link.href}
                    className="text-sm text-muted-foreground hover:text-primary"
                  >
                    {link.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
        <div className="col-span-full flex flex-col items-end sm:col-span-1 md:col-span-1">
          {/* <NewsletterForm /> */}
          <button
            type="button"
            onClick={handleCookiePreferencesClick}
            className="text-sm text-muted-foreground hover:text-primary"
          >
            Cookie preferences
          </button>
        </div>
      </div>

    </footer>
  );
}
